export default __webpack_public_path__ + "assets/ba569a8dec6cdbebdece5c2bad7f15dd.svg";